export const SDK_VERSION = '2.3.5';
export const BEACON_VERSION = '2';
//# sourceMappingURL=constants.js.map